import React from "react";
import imageData from "../../json/containerfour";
import {
  Parallax,
  ParallaxBanner,
  ParallaxBannerLayer,
  ParallaxProvider,
} from "react-scroll-parallax";
import { useNavigate } from "react-router-dom";
import './style/threeImage.css'

const SectionfourImageContainer = () => {
  const navigate = useNavigate();
  let threetext = "";
  let btnstyle = "btn-style3";
  let threetextdec = "";
  if (imageData[0].position === "end-position") {
    threetext += "text-4xl md:text-6xl text-white mb-14 font-semibold";
    threetextdec +=
      "text-base md:text-sm text-white my-10 tracking-wider  leading-loose";
      btnstyle += " bg-white m-10 px-10 py-3 ";
  }
  return (
    <ParallaxProvider>
      <div>
        {imageData?.map((x, i) => (
          <ParallaxBanner
            style={{ aspectRatio: "2 / 1", height: "100vh" }}
            className="aspect-[2/1] parallax-container"
            key={i}
          >
            <ParallaxBannerLayer
              image={x.img}
              speed={-20}
              style={{ width: "100%", backgroundPosition: "center" }}
            />
            <Parallax className="relative h-full">
              <div className={`three-text-image text-center `}>
                <span className="tag" style={{ borderRadius: "30px" }}>
                  {x.tag}
                </span>
                <p className={`${threetext} pacifico-regular`}>{x.name}</p>
                <p className={`${threetextdec}`}>{x.dec}</p>
                <div>
                  <span
                    onClick={() => navigate("/category")}
                    className={`${btnstyle} cursor-pointer `}
                  >
                    {x.btn}
                  </span>
                </div>
              </div>
            </Parallax>
          </ParallaxBanner>
        ))}
      </div>
    </ParallaxProvider>
  );
};

export default SectionfourImageContainer;
